export const DEFAULT_GTM_ID = "GTM-T6BHLH5";
